module.exports = __webpack_public_path__ + "img/adminlogo-light.a3ed3bdb.png";